import { MULTI_ITEM_STORE_DEFAULTS } from '@core/state/initial-state';

export const MULTI_ITEM_STORE_FINANCIAL_ENTRIE_DEFAULTS = {
  ...MULTI_ITEM_STORE_DEFAULTS,
  starDate: '',
  endDate: '',
};
